export default {
  state: {
    title: 'Stare',
    visible: 'Comenzi la masă vizibile',
    on: 'Comenzi la masă',
  },
  notes: {
    hidden: {
      title: 'Comandarea la masă este ascunsă',
      description:
        'Este activată, dar magazinul tău nu o afișează, așa că fiecare comandă la masă este refuzată. Activează „Comandarea la masă vizibilă” pentru a o afișa.',
      link: 'Mergi la comutator',
    },
    off: {
      title: 'Oaspeții nu pot comanda acum la masă',
      description:
        'Activați ambele comutatoare pentru a începe. Până atunci, codul QR al unei mese deschide magazinul cu Ridicare și Livrare.',
    },
    no_active_table: {
      title: 'Oaspeții nu pot comanda încă la masă',
      description: 'Adăugați mai jos o masă și activați-o.',
    },
  },
  buttons: {
    save: 'Salvează',
  },
};
